import { useMutation, useQueryClient } from '@tanstack/react-query'
import updateMarketingConsentService from 'selfServicePortal/services/CustomerServices/updateMarketingConsentService'
import { TFunction } from 'i18next'

const useUpdateMarketingConsent = (t: TFunction) => {
	const queryClient = useQueryClient()

	return useMutation(
		({
			partyId,
			allowMarketingConsent,
		}: {
			partyId: string
			allowMarketingConsent: boolean
		}) => updateMarketingConsentService(partyId, allowMarketingConsent, t),
		{
			onSuccess: () => {
				queryClient.invalidateQueries(['customerData'])
			},
			onError: (error) => {
				console.error(error)
			},
		},
	)
}

export default useUpdateMarketingConsent
